var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 19V5v14v-.025Zm0 2q-.825 0-1.413-.587Q3 19.825 3 19V5q0-.825.587-1.413Q4.175 3 5 3h14q.825 0 1.413.587Q21 4.175 21 5v8.35q-.475-.175-.975-.263Q19.525 13 19 13V5H5v14h8q0 .525.088 1.025q.087.5.262.975Zm14.175-1H16q-.425 0-.712-.288Q15 19.425 15 19t.288-.712Q15.575 18 16 18h3.175l-.9-.9Q18 16.825 18 16.413q0-.413.3-.713q.275-.275.7-.275q.425 0 .7.275l2.6 2.6q.3.3.3.7q0 .4-.3.7l-2.6 2.6q-.275.275-.687.287q-.413.013-.713-.287q-.275-.275-.275-.7q0-.425.275-.7ZM11 13v3q0 .425.288.712q.287.288.712.288t.713-.288Q13 16.425 13 16v-3h3q.425 0 .712-.288Q17 12.425 17 12t-.288-.713Q16.425 11 16 11h-3V8q0-.425-.287-.713Q12.425 7 12 7t-.712.287Q11 7.575 11 8v3H8q-.425 0-.713.287Q7 11.575 7 12t.287.712Q7.575 13 8 13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.12fd893257dedfb81c9712f694a7b32f.svg";
export { ForwardRef as ReactComponent };